import { render } from "./_History.vue?vue&type=template&id=b9362dfa&scoped=true&lang=en"
import script from "./_History.vue?vue&type=script&lang=js"
export * from "./_History.vue?vue&type=script&lang=js"

import "./_History.vue?vue&type=style&index=0&id=b9362dfa&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9362dfa"]])

export default __exports__